import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Lightweight visit tracker — fires one POST /api/track/visit per route change.
 * Skips admin users (server-side filtered too). De-duplicates same-path repeats
 * within a single SPA session to avoid double-counting StrictMode renders.
 */
export default function VisitTracker() {
  const location = useLocation();
  const lastTrackedRef = useRef("");

  useEffect(() => {
    const path = location.pathname + (location.search || "");
    if (lastTrackedRef.current === path) return;
    lastTrackedRef.current = path;

    // referrer is meaningful only for the very first page in the session
    const referrer = document.referrer || "";

    api.post("/track/visit", { path, referrer }).catch(() => {
      // Silent — analytics must never break the app
    });
  }, [location.pathname, location.search]);

  return null;
}
